export const AUTH_STORAGE_KEY = 'brickhub_customer_auth';

const AUTH_COOKIE_KEYS = new Set([
  AUTH_STORAGE_KEY,
  'refreshToken',
  'workspace_id',
  'id',
  'role',
  'user',
]);

export const AUTH_SESSION_COOKIE_KEYS = [...AUTH_COOKIE_KEYS];

/** Parent domain for cross-subdomain cookies (e.g. customer-brickhub ↔ storefront-brickhub). */
export function getSharedCookieDomainAttribute(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return '';
  }
  const parts = host.split('.');
  if (parts.length >= 2) {
    return `; domain=.${parts.slice(-2).join('.')}`;
  }
  return '';
}

export function setAuthCookie(key: string, value: string): void {
  if (typeof document === 'undefined' || !AUTH_COOKIE_KEYS.has(key)) {
    return;
  }
  const maxAge = key === 'refreshToken' ? 604800 : 86400;
  const domain = getSharedCookieDomainAttribute();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${key}=${encodeURIComponent(value)}; path=/${domain}; max-age=${maxAge}; SameSite=Lax${secure}`;
}

export function getAuthCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const nameLenPlus = name.length + 1;
  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .filter((cookie) => cookie.substring(0, nameLenPlus) === `${name}=`)
      .map((cookie) => decodeURIComponent(cookie.substring(nameLenPlus)))[0] ?? null
  );
}

export function persistAuthSession(session: {
  accessToken: string;
  refreshToken?: string;
  workspaceId?: string;
  userId?: string;
  role?: string;
}): void {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(AUTH_STORAGE_KEY, session.accessToken);
  localStorage.setItem('accessToken', session.accessToken);
  setAuthCookie(AUTH_STORAGE_KEY, session.accessToken);

  if (session.refreshToken) {
    localStorage.setItem('refreshToken', session.refreshToken);
    setAuthCookie('refreshToken', session.refreshToken);
  }

  if (session.workspaceId) {
    localStorage.setItem('workspace_id', session.workspaceId);
    setAuthCookie('workspace_id', session.workspaceId);
  }

  if (session.userId) {
    localStorage.setItem('id', session.userId);
    setAuthCookie('id', session.userId);
  }

  if (session.role) {
    localStorage.setItem('role', session.role);
    setAuthCookie('role', session.role);
  }
}
